import { render, staticRenderFns } from "./ProgressGlobalHeader.vue?vue&type=template&id=479d3dc9&scoped=true"
import script from "./ProgressGlobalHeader.vue?vue&type=script&lang=ts"
export * from "./ProgressGlobalHeader.vue?vue&type=script&lang=ts"
import style0 from "./ProgressGlobalHeader.vue?vue&type=style&index=0&id=479d3dc9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479d3dc9",
  null
  
)

export default component.exports